import { Tag } from 'antd';
import './TriggerItem.css';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col } from 'react-bootstrap';
import IconButton from '../common/IconButton';
import { NotificationTrigger } from '../../models/Notification';

const methodColors = {
  GET: 'blue',
  POST: 'orange',
  PUT: 'green',
  PATCH: 'purple',
  DELETE: 'red',
}

type Props = {
  trigger: NotificationTrigger;
  onEdit: React.MouseEventHandler<HTMLButtonElement>;
  onDelete: React.MouseEventHandler<HTMLButtonElement>;
}

export default function TriggerItem({ trigger, onEdit, onDelete }: Props) {
  return (
    <div className="trigger-item">
      <Col>
        <h6 className="mb-1">{trigger.name}</h6>
        <Tag color={methodColors[trigger.method!] || 'geekblue'}>
          <b>{trigger.method}</b>
          <span className="ms-2 font-monospace">{trigger.url}</span>
        </Tag>
        {trigger.headers?.length > 0 && (
          <Tag>
            <FontAwesomeIcon icon={solid('ellipsis-v')} />
            <span className="ms-2">{trigger.headers.length} Headers</span>
          </Tag>
        )}
        {trigger.queryParams?.length > 0 && (
          <Tag>
            <FontAwesomeIcon icon={solid('ellipsis-h')} />
            <span className="ms-2">{trigger.queryParams.length} Query Parameters</span>
          </Tag>
        )}
      </Col>

      <div className="px-3">
        <IconButton type="button" onClick={onEdit}>
          <FontAwesomeIcon icon={solid('pen')} />
        </IconButton>
        <IconButton type="button" className="ms-3 text-danger" onClick={onDelete}>
          <FontAwesomeIcon icon={solid('trash')} />
        </IconButton>
      </div>
    </div>
  )
}
